import { Component, OnInit } from '@angular/core'
import { Entity } from '@model/entities/entity'
import { DialogService } from '@service/dialog.service'
import { EntityTypeConfig } from '@model/entity-type-config'
import { EntityTypeConfigService } from '@service/entity-type-config.service'
import { ScrollService } from '@service/scroll.service'
import { ProfileStateComponent } from '@component/profile/profile-state.component'
import { StateService } from '@service/state.service'
import { EntityTypeIdentifier } from '@type/entity-type-identifier'
import { MobileService } from '@service/mobile.service'
import { SliderImagesService } from '@service/slider-images.service'

type navigationItems = {
  [id: string]: {
    caption: string,
    data: Array<Entity>,
    createLabel: string,
  }
}

@Component({
  selector: 'app-my-content',
  templateUrl: './my-content.component.html',
  styleUrls: ['./my-content.component.scss']
})
export class MyContentComponent extends ProfileStateComponent implements OnInit {
  public hasSliderImages: boolean = false;

  constructor(
    private dialogService: DialogService,
    private entityTypeConfigService: EntityTypeConfigService,
    protected scrollService: ScrollService,
    public StateService: StateService,
    public MobileService: MobileService,
    public sliderImagesService: SliderImagesService
  ) {
    super(
      scrollService
    )
  }

  get navigationItemKeys(): string[] {
    return Object.keys(this.navigationItems)
  }

  public loading: boolean = false

  // entity types
  // data is filled later by rest fetching
  public navigationItems: navigationItems = {
    "all": {
      caption: 'Alle',
      createLabel: '',
      data: [],
    },
    "blog": {
      caption: 'Blog',
      createLabel: 'Blog Eintrag erstellen',
      data: [],
    },
    "advert": {
      caption: 'Marktplatz',
      createLabel: 'Marktplatz Anzeige aufgeben',
      data: [],
    },
    // "wiki": {
    //   caption: 'Wiki',
    //   createLabel: 'Wiki Artikel erstellen',
    //   data: [],
    // },
    "job": {
      caption: 'Jobbörse',
      createLabel: 'Jobinserat erstellen',
      data: [],
    },
  }
  public selectedKey: string = 'all'

  ngOnInit() {
    super.ngOnInit()
    this.getAllEntities()

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    });

    this.sliderImagesService.checkHasSliderImages('profile');
  }

  private getAllEntities() {

    this.loading = true

    let promises = [
      this.getEntity('job'),
      this.getEntity('blog'),
      this.getEntity('advert'),
      // this.getEntity('wiki'),
    ]

    Promise.all(promises)
      .then(() => {
        for (let key of Object.keys(this.navigationItems)) {
          this.navigationItems[key]["data"] = this.navigationItems[key]["data"].sort((a, b) => {
            return a.created_at > b.created_at ? -1 : 0
          })
        }
      })
      .finally(() => {
        this.loading = false
      })
  }

  // tried to keep it as generic as possible in a very, very short time frame
  private getEntity(
    entityTypeIdentifier: EntityTypeIdentifier
  ): Promise<void> {

    return new Promise((resolve, reject) => {

      let entityTypeConfig: EntityTypeConfig = this.entityTypeConfigService.getConfigByName(
        entityTypeIdentifier
      )

      entityTypeConfig.service.getMy()
        .then((entities: Entity[]) => {
          this.navigationItems[entityTypeIdentifier].data = entities
          this.navigationItems["all"].data = this.navigationItems["all"].data.concat(entities)
          resolve()
        })
        .catch(() => reject())

    })
  }

  public gotoCreateState() {
    this.StateService.goto(
      this.entityTypeConfigService.getConfigByName(this.selectedKey).createstate
    )
  }

  public delete(entity: Entity) {

    this.dialogService.ensureDialog("Willst Du den Beitrag wirklich löschen?")
      .then((result: boolean) => {
        if (result) {

          let entityTypeConfig: EntityTypeConfig = this.entityTypeConfigService.getConfigByName(
            entity.entityTypeIdentifier
          )

          this.loading = true
          entityTypeConfig.service.delete(entity.id)
            .then(() => {

              // remove element from single entity type list (like wiki / blog / advert etc)
              this.navigationItems[entity.entityTypeIdentifier].data = this.navigationItems[entity.entityTypeIdentifier].data.filter((d) => {
                return d.id != entity.id
              })

              // remove element from all list
              this.navigationItems["all"].data = this.navigationItems["all"].data.filter((d) => {
                return d.id != entity.id
              })

              // remove element from selected list
              this.navigationItems[this.selectedKey].data = this.navigationItems[this.selectedKey].data.filter((d) => {
                return d.id != entity.id
              })
            })
            .finally(() => {
              this.loading = false
            })

        }
      })
  }

  public trackByFn(index, item) {
    return item.id
  }
}